<template>
    <div class="navbar-item has-dropdown is-hoverable">
        <a class="navbar-item">
            <FontAwesomeIcon :icon="faUserCircle" />
        </a>
        <div class="navbar-dropdown is-right" style="min-width: 12rem;">
            <div class="navbar-item is-flex-direction-column is-align-items-start is-gapless">
                <p class="has-text-secondary"><small>signed in as</small></p>
                <p>{{ userEmail }}</p>
            </div>
            <hr class="navbar-divider">
            
            <a v-if="!store.isFrontendOnly" class="navbar-item icon-text" @click="store.openPreferencesModal">
                <span class="icon">
                    <FontAwesomeIcon :icon="faGear" />
                </span>
                <span>Preferences</span>
            </a>
            
            <hr v-if="!store.isFrontendOnly" class="navbar-divider">
            <a class="navbar-item icon-text" @click="handleSignOut">
                <span class="icon">
                    <FontAwesomeIcon :icon="faSignOutAlt" />
                </span>
                <span>Sign Out</span>
            </a>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faUserCircle, faSignOutAlt, faGear } from '@fortawesome/free-solid-svg-icons';
import { useBlocksStore } from '../stores/blocks';

const store = useBlocksStore();

const userEmail = computed(() => {
    return store.userSession?.userEmail;
});

const handleSignOut = async () => {
    try {
        await store.signOut();
    } catch (error) {
        console.error('Error signing out:', error);
    }
};
</script>
